import { useWindowSize } from 'hooks/useWindowSize';
import React, { ElementType, useLayoutEffect, useRef } from 'react';
import shave from 'shave';

interface Props {
  maxHeight: number;
  children: React.ReactNode;
  isEnabled?: boolean;
  as?: ElementType;
  className?: string;
  setHasMore?: (hasMore: boolean) => void;
}

/**
 * This is wrapper component of the vanilla JavaScript library 'shave' to easily reuse it throughout
 * the app and stay in “React Mode”.
 */
export const Shave = ({
  children,
  maxHeight,
  isEnabled = true,
  as: Tag = 'div',
  className,
  setHasMore,
}: Props) => {
  const contentRef = useRef<HTMLElement>(null);
  const windowSize = useWindowSize();

  useLayoutEffect(() => {
    if (isEnabled) {
      shave(contentRef.current as Element, maxHeight, {
        character: ' ...',
      });
      // Text is shaved off when its container has children, namely two spans (end character, remaining text) and a text node.
      setHasMore?.(!!contentRef.current?.childElementCount);
    }
  }, [maxHeight, isEnabled, windowSize, setHasMore]);

  return (
    <Tag className={className} key={String(isEnabled)} ref={contentRef}>
      <div>{children}</div>
    </Tag>
  );
};

export default Shave;
